export { default as InventoryItemDetail } from "./InventoryItemDetail";
